import {
  FETCH_TASKS_REQUEST,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILURE,
} from '../types/taskTypes';
import axiosInstance from '../../utils/setupAxios';

export const EMPTY_TASK_FILTER_OPTIONS = {
  app_versions: [],
  country_codes: [],
  os_list: [],
  os_versions: [],
};

export const normalizeTaskFilterOptions = (data) => {
  if (!data || typeof data !== 'object') {
    return { ...EMPTY_TASK_FILTER_OPTIONS };
  }

  const toStringList = (value) => {
    if (!Array.isArray(value)) return [];
    return value
      .map((item) => (item == null ? '' : String(item).trim()))
      .filter((item) => item !== '');
  };

  return {
    app_versions: toStringList(data.app_versions),
    country_codes: toStringList(data.country_codes),
    os_list: toStringList(data.os_list),
    os_versions: toStringList(data.os_versions),
  };
};

export const fetchTaskFilters = async () => {
  const response = await axiosInstance.get('/holo/tasks/filters');
  if (response.data?.success) {
    return normalizeTaskFilterOptions(response.data.data);
  }
  return { ...EMPTY_TASK_FILTER_OPTIONS };
};

export const deleteTask = async (taskId) => {
  const response = await axiosInstance.delete(`/holo/tasks/${taskId}`);
  return response.data?.success === true;
};

export const fetchTasks = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_TASKS_REQUEST });
  try {
    const response = await axiosInstance.get('/holo/tasks', { params });
    if (response.data.success) {
      dispatch({ type: FETCH_TASKS_SUCCESS, payload: response.data.data });
    } else {
      dispatch({ type: FETCH_TASKS_FAILURE, payload: response.data.message || 'Failed to fetch tasks' });
    }
  } catch (error) {
    dispatch({ type: FETCH_TASKS_FAILURE, payload: error.response?.data?.message || 'Failed to fetch tasks' });
  }
};
